import { render } from "./BetsElement.vue?vue&type=template&id=86215c4a&scoped=true"
import script from "./BetsElement.vue?vue&type=script&lang=js"
export * from "./BetsElement.vue?vue&type=script&lang=js"

import "./BetsElement.vue?vue&type=style&index=0&id=86215c4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86215c4a"]])

export default __exports__